import { createContext, useContext } from 'react';
import { FetchStatuses } from '../../types/FetchStatus';
import { useFetchAllAppSettings } from '../../hooks/internal/useFetchAllAppSettings';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_STATE = {
  status: FetchStatuses.IDLE,
  data: null
};
export const CrmLinksContext = /*#__PURE__*/createContext(INITIAL_STATE);
export const useCrmLinksContext = () => {
  return useContext(CrmLinksContext);
};
export const CrmLinksContextProvider = ({
  children
}) => {
  const allAppSettingsState = useFetchAllAppSettings();
  return /*#__PURE__*/_jsx(CrmLinksContext.Provider, {
    value: allAppSettingsState,
    children: children
  });
};